module.exports = __webpack_public_path__ + "static/media/FCMH-Raster-02.d42bec67.svg";